import React, { Fragment, useRef, useState, useEffect } from 'react'

import { useSelector, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { LightBoxModal } from '.'
import { useEventListener } from '../../_helpers'
import {
    Container,
    Meta,
    Title,
    devices,
    colors,
} from '../Common'

const ImageCard = ({ image, openModal }) => {
    const [spans, setSpans] = useState(0)
    const imageRef = useRef()

    const setSpan = () => {
        const height = imageRef.current.clientHeight
        const spans = Math.ceil(height / 10)
        setSpans(spans)
    }

    useEffect(() => {
        setSpan()
    }, [])

    useEventListener('load', setSpan)

    return (
        <div style={{ gridRowEnd: `span ${spans}` }}>
            <img ref={imageRef} src={image.image} alt={image.alt_text} onClick={openModal} />
        </div>
    )
}


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery } = page
    const [showLightBox, setShowLightBox] = useState(false)

    if (notFound) return <Redirect to='/' />

    const openModal = () => setShowLightBox(true)

    const closeModal = () => setShowLightBox(false)

    return (
        <Fragment>
            <Meta page={page} />
            <PageContainer>
                <Title>{page.title}</Title>
                {gallery ?
                    showLightBox ?
                        <LightBoxModal
                            slides={gallery}
                            showLightBox={showLightBox}
                            closeModal={closeModal}
                        /> :
                        <ImageList>
                            {gallery.map((image, i) => <ImageCard key={i} image={image} openModal={openModal} />)}
                        </ImageList>
                    : ''}
            </PageContainer>
        </Fragment>
    )
}

const PageContainer = styled(Container)`
    min-height: 100vh;
    background: ${colors.black};
    padding: 50px;
`

const ImageList = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 33%);
    justify-content: space-evenly;
    grid-row-gap: 10px;
    grid-auto-rows: 1px;

    img {
        width: 93%;
        border: 10px solid white;
        cursor: pointer;
    }
`

export default PageView
